"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carlineBaseStrategy = void 0;
const vehicleKey_1 = require("../../../utils/vehicleKey");
const constants_1 = require("../../constants");
const mustacheRenderer_1 = require("../../renderer/mustacheRenderer");
const textResources_1 = require("../../textResources");
const carlineBaseStrategy = ({ carline, locale, i18nlanguage }) => {
    const resources = new textResources_1.I18nText(locale, i18nlanguage);
    const vehicleType = (0, vehicleKey_1.getVehicleKeyForCarline)(carline);
    let formattedConsumption;
    let formattedEmission;
    const { eecModel } = carline;
    //do we refactor this into some sort of Chain of responsibility? or a map of functions?
    //if envkv is the only branch, this should be simple enough, but if any other market has extra needs, this will get messy
    //Consumption combined
    if (carline.eecModel.eecFuelValue) {
        formattedConsumption = (0, mustacheRenderer_1.substituteTemplate)(resources.get(`vue.range.consumption.combined.${vehicleType}`), {
            consumptionRange: carline.eecModel.eecFuelValue,
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        });
    }
    //emission
    if (carline.eecModel.eecCo2Value) {
        const templateKey = eecModel.isHybrid ? "vue.range.emission.combined.hybrid" : "vue.range.emission.combined";
        formattedEmission = (0, mustacheRenderer_1.substituteTemplate)(resources.get(templateKey), {
            emissionRange: carline.eecModel.eecCo2Value,
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        });
    }
    const ret = {
        formattedConsumption,
        formattedEmission,
        footnote: {
            reference: constants_1.FOOTNOTE_REFERENCE,
        },
    };
    return ret;
};
exports.carlineBaseStrategy = carlineBaseStrategy;
